import { PowerPlanEvent } from "@/services/powerPlans/types";
import { RecurenceEnum } from "@/services/posts/types";
import moment, { Moment } from "moment";

export function isPowerPlanEventOnDate(powerPlanEvent: PowerPlanEvent, date: Moment) {
    // we wrap fromDate and toDate in js date object to handle different date strings
    return (moment(new Date(powerPlanEvent.fromDate)).isSameOrBefore(date, "year") && moment(new Date(powerPlanEvent.fromDate)).isSameOrBefore(date, "month") &&
    moment(new Date(powerPlanEvent.fromDate)).isSameOrBefore(date, "day")) &&
        (powerPlanEvent.neverending || (moment(new Date(powerPlanEvent.toDate)).isSameOrAfter(date, "year") &&
        moment(new Date(powerPlanEvent.toDate)).isSameOrAfter(date, "month") &&
        moment(new Date(powerPlanEvent.toDate)).isSameOrAfter(date, "day"))) &&
        filterAccordingRecurence(powerPlanEvent, date);
}

export function isPowerPlanEventRecurringOnDate(powerPlanEvent: PowerPlanEvent, time: Moment) {
    const date = moment(time).startOf("d");
    if (!isPowerPlanEventOnDate(powerPlanEvent, date)) {
        return false;
    }
    let dayOfWeek = time.day();
    if (dayOfWeek === 0) {
        dayOfWeek = 7;
    }
    switch (powerPlanEvent.recurenceType) {
    case RecurenceEnum.daily:
        return true;
    case RecurenceEnum.weekly:
        return powerPlanEvent.recurenceValues.includes(dayOfWeek);
    case RecurenceEnum.monthly:
        return powerPlanEvent.recurenceValues.includes(time.date());
    case RecurenceEnum.yearly:
        return moment(powerPlanEvent.yearly).format("MM DD").toString() === date.format("MM DD").toString();
    default:
        return false;
    }
}

function isPowerPlanEventRecurringOnTimeOfDay(powerPlanEvent: PowerPlanEvent, time: Moment) {
    const date = moment(time).startOf("d");
    const fromTime = moment(powerPlanEvent.fromTime);
    const toTime = moment(powerPlanEvent.toTime);
    const endsInTheMorning = toTime.isBefore(fromTime);
    const startTime = moment(date).add(fromTime.diff(moment(fromTime).startOf("d"), "ms"));
    const endTime = moment(date).add(toTime.diff(moment(toTime).startOf("d"), "ms"));
    if (endsInTheMorning) {
        endTime.add(1, "d");
    }
    return powerPlanEvent.allDay || (time.isSameOrAfter(startTime) && time.isSameOrBefore(endTime));
}

export function isPowerPlanEventRecurring(powerPlanEvent: PowerPlanEvent, time: Moment) {
    return isPowerPlanEventRecurringOnDate(powerPlanEvent, time) &&
        isPowerPlanEventRecurringOnTimeOfDay(powerPlanEvent, time);
}

function filterAccordingRecurence(powerPlanEvent: PowerPlanEvent, date: Moment) {
    let dayOfWeek = date.weekday();
    if (dayOfWeek === 0) {
        dayOfWeek = 7;
    }
    switch (powerPlanEvent.recurenceType) {
    case RecurenceEnum.daily:
        return true;
    case RecurenceEnum.weekly:
        return powerPlanEvent.recurenceValues.includes(dayOfWeek);
    case RecurenceEnum.monthly:
        return powerPlanEvent.recurenceValues.includes(date.date());
    case RecurenceEnum.yearly:
        return moment(powerPlanEvent.yearly).format("MM DD").toString() === date.format("MM DD").toString();
    default:
        return false;
    }
}
